import React, { Component } from 'react';

import Section from './Section';

const RenaperIntroduction = ({ onFinish }) => {
  return (<div style={{
      position: "relative",
      display: "block",
      width: "100%",
      height: "100%",
      overflowY: "scroll",
      background: "#ffffff",
    }}>
    <Section className="intro_form">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
          </div>
          <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
            <h4><b>Ahora vamos a validar tu identidad. Tené el DNI a mano y asegurate de estar en un lugar tranquilo y con buena luz.</b></h4>
          </div>
          <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
            <span>
              <p style={{
                fontFamily: "Rubik,sans-serif!important",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "150%",
              }}>
                <i className="fa fa-check" ariaHidden="true"></i> Escaneamos tu DNI
              </p>
              <p style={{
                fontFamily: "Rubik,sans-serif!important",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "150%",
              }}>
                <i className="fa fa-check" ariaHidden="true"></i> Validamos tu identidad
              </p>
              <p style={{
                fontFamily: "Rubik,sans-serif!important",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "150%",
              }}>
                <i className="fa fa-check" ariaHidden="true"></i> Chequeamos tus datos
              </p>
            </span>
          </div>
          <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                  <button 
                    type="submit"
                    className="btn btn-warning btn-lg pd-button pd-form"
                    onClick={(event) => {
                      event.preventDefault();
                      onFinish();
                    }}>
                      Entendido
                  </button>
              </div>
          </div>
        </div>
    </Section>
    </div>)
}

module.exports = RenaperIntroduction;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperIntroduction.js
 **/